Object.defineProperty(exports, "__esModule", { value: true });
exports.getGatsbyImageData = void 0;
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
function getGatsbyImageData({ image, backgroundColor, options = {}, layout = `constrained`, ...props }) {
    const urlBuilder = ({ baseUrl, width, height, options: { quality, fit = 'crop', lossless }, }) => {
        const props = [
            ['w', width],
            ['h', height],
            ['auto', 'format'],
            ['bg', backgroundColor],
            ['q', quality],
            ['lossless', lossless],
            ['fit', fit],
        ];
        const query = props
            .filter(([, val]) => typeof val !== 'undefined')
            .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
            .join('&');
        return `${baseUrl}?${query}`;
    };
    return (0, gatsby_plugin_image_1.getImageData)({
        baseUrl: image.url,
        sourceWidth: image.width,
        sourceHeight: image.height,
        layout,
        urlBuilder,
        backgroundColor,
        pluginName: 'gatsby-components',
        options,
        ...props,
    });
}
exports.getGatsbyImageData = getGatsbyImageData;
//# sourceMappingURL=get-gatsby-image-data.js.map